/**
 * Identity of a picked/editable sales line.
 *
 * A line drawn from a CONFIGURABLE equipment item keeps the configurable
 * catalog item's `lineItemId` — that's its pricing and attribution source — so
 * the catalog id alone does not identify the row: two configurations of the
 * same item would collapse into one. Row-level operations (merge on re-add,
 * dedupe) key on the item AND the chosen configuration.
 */
export function lineIdentityKey(item: { lineItemId: string; configurationName?: string }): string {
  return item.configurationName ? `${item.lineItemId}::${item.configurationName}` : item.lineItemId;
}
